import React from "react";
import { Tabs, Tab } from "react-bootstrap";

import { ParameterGroupTab } from "./ParameterGroupTab";
import { ParameterTab } from "./ParameterTab";

export const BusinessParameterPage = () => {
  return (
    <>
      <div>
        <Tabs defaultActiveKey="Parameter Group" id="uncontrolled-tab-example">
          <Tab eventKey="Parameter Group" title="Parameter Group">
            <ParameterGroupTab />
          </Tab>
          <Tab eventKey="Parameter" title="Parameter">
            <ParameterTab />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};
